import React from "react";
import { Star, Quote } from "lucide-react";

export function Stars({ count = 5, className = "" }) {
  return (
    <div className={`flex gap-0.5 ${className}`} aria-label={`${count} étoiles sur 5`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          size={14}
          className={i < count ? "fill-[#C29A73] text-[#C29A73]" : "text-sand-300"}
        />
      ))}
    </div>
  );
}

export default function TestimonialCard({ name, rating, text, dark = false, testid }) {
  return (
    <article
      data-testid={testid}
      className={`rounded-2xl p-7 border ${
        dark
          ? "bg-sand-800 border-sand-700 text-sand-100"
          : "bg-white/70 border-sand-300/60 text-sand-800"
      }`}
    >
      <Quote
        size={28}
        className={`${dark ? "text-sand-500" : "text-[#B07A45]"} mb-4`}
        aria-hidden="true"
      />
      <p className="leading-relaxed text-[15px] mb-5">« {text} »</p>
      <div className="flex items-center justify-between">
        <p className={`font-medium tracking-wide text-sm ${dark ? "text-sand-300" : "text-sand-900"}`}>
          {name}
        </p>
        <Stars count={rating} />
      </div>
    </article>
  );
}
